import { useParams } from 'react-router-dom';

export const useAssignmentId = () => {
  const { id } = useParams<Dictionary<string>>();

  return id!;
};
